// 2021/11/9 bryan
const coordinatesconvert = {

  x_PI: 3.14159265358979324 * 3000.0 / 180.0,
  PI: 3.1415926535897932384626,
  a: 6378245.0,
  ee: 0.00669342162296594323,

  // javascript 转换
  lonLat2Mercator(lonlat) {
    const mercator = {
      x: 0,
      y: 0
    }
    const earthRad = 6378137.0
    mercator.x = lonlat.lng * Math.PI / 180 * earthRad
    const a = lonlat.lat * Math.PI / 180
    mercator.y = earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)))
    return mercator
  },
  // WGS84转GCj02 //lng=113.07263528534892, lat = 27.79955328526421
  wgs84togcj02(lng, lat) {
    let dlat = coordinatesconvert.transformlat(lng - 105.0, lat - 35.0)
    let dlng = coordinatesconvert.transformlng(lng - 105.0, lat - 35.0)
    const radlat = lat / 180.0 * coordinatesconvert.PI
    let magic = Math.sin(radlat)
    magic = 1 - coordinatesconvert.ee * magic * magic
    const sqrtmagic = Math.sqrt(magic)
    dlat = (dlat * 180.0) / ((coordinatesconvert.a * (1 - coordinatesconvert.ee)) / (magic * sqrtmagic) * coordinatesconvert.PI)
    dlng = (dlng * 180.0) / (coordinatesconvert.a / sqrtmagic * Math.cos(radlat) * coordinatesconvert.PI)
    const mglat = lat + dlat
    const mglng = lng + dlng
    return mglng + ',' + mglat
  },
  // GCJ02 转换为 WGS84
  gcj02towgs84(lng, lat) {
    let dlat = coordinatesconvert.transformlat(lng - 105.0, lat - 35.0)
    let dlng = coordinatesconvert.transformlng(lng - 105.0, lat - 35.0)
    const radlat = lat / 180.0 * coordinatesconvert.PI
    let magic = Math.sin(radlat)
    magic = 1 - coordinatesconvert.ee * magic * magic
    const sqrtmagic = Math.sqrt(magic)
    dlat = (dlat * 180.0) / ((coordinatesconvert.a * (1 - coordinatesconvert.ee)) / (magic * sqrtmagic) * coordinatesconvert.PI)
    dlng = (dlng * 180.0) / (coordinatesconvert.a / sqrtmagic * Math.cos(radlat) * coordinatesconvert.PI)
    const mglat = lat - dlat
    const mglng = lng - dlng
    return mglat + ',' + mglng
  },
  transformlat(lng, lat) {
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * coordinatesconvert.PI) + 20.0 * Math.sin(2.0 * lng * coordinatesconvert.PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lat * coordinatesconvert.PI) + 40.0 * Math.sin(lat / 3.0 * coordinatesconvert.PI)) * 2.0 / 3.0
    ret += (160.0 * Math.sin(lat / 12.0 * coordinatesconvert.PI) + 320 * Math.sin(lat * coordinatesconvert.PI / 30.0)) * 2.0 / 3.0
    return ret
  },
  transformlng(lng, lat) {
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * coordinatesconvert.PI) + 20.0 * Math.sin(2.0 * lng * coordinatesconvert.PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lng * coordinatesconvert.PI) + 40.0 * Math.sin(lng / 3.0 * coordinatesconvert.PI)) * 2.0 / 3.0
    ret += (150.0 * Math.sin(lng / 12.0 * coordinatesconvert.PI) + 300.0 * Math.sin(lng / 30.0 * coordinatesconvert.PI)) * 2.0 / 3.0
    return ret
  }
}
export {
  coordinatesconvert
}
